module.exports = "/images/clouds_light.png?dad65c05c93a6fbc87ba0e063c2a56a9";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/clouds_light.png
// module id = hkwi
// module chunks = 0